<template>
    <footer class="bg-[#f8f9fc] sticky-footer">
                <div class="container my-auto akkurate-small">
                    <div class="text-center my-auto copyright"><span>Copyright © Akkurate 2024</span></div>
                </div>
            </footer>
</template>
<script>
 export default {
    name:'Footer'
 }

</script>
